<template>
  <ul class="select-tree-outer for-small-box">
    <!-- 片头按钮 -->
    <li>
      <ul class="chapter-list" style="display: block">
        <li
          class="chapter-item"
          :class="Zhead ? 'cur' : ''"
          @click.stop="changeHeadTail('Head')"
        >
          <p class="title-detail fixed-video">
            <b>{{$t('Opening')}}</b>
          </p>
        </li>
      </ul>
    </li>
    <li
      @click="open(index)"
      v-for="(item, index) in partList"
      :key="item.part_id"
    >
      <h6 class="course-title">{{ item.part_title }}</h6>
      <ul
        class="chapter-list"
        :style="item.openStatus ? 'display:block;' : 'display:none;'"
      >
        <li
          class="chapter-item"
          v-for="(itm, idx) in item.chapter_list"
          @click.stop="changeStatus(itm, idx, index)"
          :key="itm.chapter_id"
          :class="{
            'chapter-item cur': itm.aliveStatus,
            'chapter-item': !itm.aliveStatus,
          }"
        >
          <i :class="chapterType(itm.chapter_type)"></i>
          <p class="title-detail">
            <b v-if="false">{{ chapterTypeTxt(itm.chapter_type) }}:</b>
            {{ itm.chapter_title }}
          </p>
          <span :class="getFinishStatus(itm.is_finished)"></span>
        </li>
      </ul>
    </li>
    <!-- 片尾按钮 -->
    <li>
      <ul class="chapter-list" style="display: block">
        <li
          class="chapter-item"
          :class="Ztail ? 'cur' : ''"
          @click.stop="changeHeadTail('Tail')"
        >
          <p class="title-detail fixed-video">
            <b>{{$t('EndVideo')}}</b>
          </p>
        </li>
      </ul>
    </li>
  </ul>
</template>
<script>
import psCommonMethods from './mixins/index.js'
export default {
  name: 'SelectTree',
  mixins: [psCommonMethods],
  data () {
    return {
      partList: this.data.part_list
    }
  },
  created () {
    this.initData()
  },
  computed: {
    lessonLocation () {
      return this.$store.state.lessonLocation
    },
    currentChapterIndex () {
      return this.$store.state.currentChapterIndex
    },
    currentPartIndex () {
      return this.$store.state.currentPartIndex
    },
    Zhead () {
      return this.$store.state.Zhead
    },
    Ztail () {
      return this.$store.state.Ztail
    }
  },
  watch: {
    lessonLocation (nv) {
      console.log('更新了学习进度', nv)
      this.uploadStatus(nv)
      this.$store.commit('showPrev', true)
    },
    // 切换小节时改变选中状态
    currentChapterIndex (nv) {
      const cIndex = this.$store.state.currentChapterIndex
      const pIndex = this.$store.state.currentPartIndex
      let data = this.data.part_list[pIndex].chapter_list[cIndex]
      this.changeStatus(data, cIndex, pIndex)
    },
    // 切换章节时改变选中状态
    currentPartIndex () {
      const cIndex = this.$store.state.currentChapterIndex
      const pIndex = this.$store.state.currentPartIndex
      let data = this.data.part_list[pIndex].chapter_list[cIndex]
      this.changeStatus(data, cIndex, pIndex)
    }
  },
  methods: {
    initData () {
      const scormId = this.data.scorm_id
      let lessonLocation, conversionData
      // conversionData = [...this.data];
      conversionData = this.data
      // if(localStorage.getItem(scormId+'lessonLocation')){ //读取章节完成进度
      if (this.$store.state.lessonLocation) {
        // 读取章节完成进度
        // lessonLocation = localStorage.getItem(scormId+'lessonLocation');
        // this.$store.commit("lessonLocation",lessonLocation);
        lessonLocation = this.$store.state.lessonLocation
        let chapterStatusStr = lessonLocation.split('||')[0]
        let currentChapter = lessonLocation.split('||')[1]
        let chapterStatusArr = chapterStatusStr.split('|')
        chapterStatusArr.forEach((item, index) => {
          // conversionData.part_list[index].openStatus = false;
          if (index < this.data.part_list.length) {
            conversionData.part_list[index].openStatus = true // 默认全部章节展开
            item.split('').forEach((itm, idx) => {
              if (idx < this.data.part_list[index].chapter_list.length) {
                conversionData.part_list[index].chapter_list[
                  idx
                ].is_finished = parseInt(itm)
                conversionData.part_list[index].chapter_list[
                  idx
                ].aliveStatus = false
              }
            })
          }
        })
        let pIndex = currentChapter.split('-')[0]
        let cIndex = currentChapter.split('-')[1]
        if (pIndex == 0 && cIndex == 0 && chapterStatusArr.join('').indexOf('1') < 0) {
          this.changeHeadTail('Head')
          this.$store.commit('setInFixedVideo', 'auto')
        } else {
          conversionData.part_list[pIndex].chapter_list[
            cIndex
          ].aliveStatus = true
        }
        // conversionData.part_list[pIndex].chapter_list[
        //   cIndex
        // ].aliveStatus = true;
      } else {
        this.changeHeadTail('Head')
        this.$store.commit('setInFixedVideo', 'auto')
        conversionData.part_list.forEach(item => {
          // item.openStatus = false;
          item.openStatus = true // 默认全部章节展开
          item.chapter_list.forEach(itm => {
            itm.is_finished = 0
            itm.aliveStatus = false
          })
        })
      }
      this.partList = conversionData.part_list
    },
    open (index) {
      const data = [...this.partList]
      data[index].openStatus = !data[index].openStatus
      this.partList = data
    },
    changeStatus (item, idx, index) {
      this.$store.commit('currentPartIndex', index) // 当前章节数组下标
      this.$store.commit('currentChapterIndex', idx) // 当前小节数组下标
      this.$store.commit('cur_data', this.partList[index].chapter_list[idx])// 保存当前小节数组对象
      let type, quiz, chapterId
      type = item.chapter_type // 当前小节类型 1 视频  2.小测验  3.图文
      chapterId = item.chapter_id // 章节ID
      if (item.chapter_content) {
        quiz = item.chapter_content.quiz_type
      }
      this.intoDetail(type, quiz, chapterId)
      const data = [...this.partList]
      data.forEach((item, index) => {
        item.chapter_list.forEach((itm, idx) => {
          if (itm.chapter_id === chapterId) {
            itm.aliveStatus = true
          } else {
            itm.aliveStatus = false
          }
        })
      })
      this.partList = data
    },
    chapterType (type) {
      type = parseInt(type)
      switch (type) {
        case 1:
          return 'video'
        case 2:
          return 'test'
        case 4:
          return 'tuwen'
      }
    },
    chapterTypeTxt (type) {
      type = parseInt(type)
      switch (type) {
        case 1:
          return '视频'
        case 2:
          return '测验'
        case 4:
          return '图文'
      }
    },
    getFinishStatus (status) {
      if (status === 1) {
        return 'status finished'
      } else {
        return 'status'
      }
    },
    uploadStatus (lessonLocation) {
      // let conversionData = [...this.data];
      let conversionData = this.data
      let chapterStatusStr = lessonLocation.split('||')[0]
      let currentChapter = lessonLocation.split('||')[1]
      let chapterStatusArr = chapterStatusStr.split('|')
      chapterStatusArr.forEach((item, index) => {
        item.split('').forEach((itm, idx) => {
          if (idx < conversionData.part_list[index].chapter_list.length) {
            conversionData.part_list[index].chapter_list[
              idx
            ].is_finished = parseInt(itm)
            conversionData.part_list[index].chapter_list[idx].aliveStatus = false
          }
        })
      })
      let pIndex = currentChapter.split('-')[0]
      let cIndex = currentChapter.split('-')[1]
      conversionData.part_list[pIndex].openStatus = true
      conversionData.part_list[pIndex].chapter_list[cIndex].aliveStatus = true
      this.partList = conversionData.part_list
    }
  }
}
</script>

<style lang="less">
.select-tree-outer {
  min-width: 160px;
  background: #fff;
  font-size: 14px;
  &.for-small-box {
    .title-detail {
      width: 60px;
    }
  }
  > li {
    margin: 3px 0;
    padding: 0 15px;
    .course-title {
      min-height: 30px;
      line-height: 30px;
      font-weight: bold;
      font-size: 18px;
      color: #252631;
    }
    .chapter-list {
      display: none;
      // transition: display .8s;
      .chapter-item {
        display: flex;
        padding: 10px;
        cursor: pointer;
        color: #252631;
        i {
          display: block;
          width: 18px;
          height: 18px;
          margin-top: 2px;
          &.video {
            background: url("../../assets/img/pc/video_off.png") no-repeat
              center center;
          }
          &.test {
            background: url("../../assets/img/pc/test_off.png") no-repeat center
              center;
          }
          &.tuwen {
            background: url("../../assets/img/pc/tuwen_off.png") no-repeat
              center center;
          }
        }
        .title-detail {
          max-width: 300px;
          min-width: 60px;
          text-align: left;
          line-height: 1.5;
          flex-grow: 1;
          text-align: justify;
          padding: 0 10px;
        }
        .fixed-video {
          display: flex;
          align-items: center;
          padding: 0;
          &::before {
            content: "";
            width: 6px;
            height: 6px;
            background: #aaa;
            border-radius: 50%;
            margin-right: 6px;
          }
        }
        .status {
          display: block;
          width: 12px;
          height: 10px;
          margin-top: 4px;
          &.finished {
            background: url("../../assets/img/icon.png") no-repeat -10px -10px;
          }
        }
        &.cur {
          color: #005587;
          font-weight: bold;
          .fixed-video::before {
            background: #005587;
          }
          i {
            &.video {
              background: url("../../assets/img/pc/video_on.png") no-repeat
                center center;
            }
            &.test {
              background: url("../../assets/img/pc/test_on.png") no-repeat
                center center;
            }
            &.tuwen {
              background: url("../../assets/img/pc/tuwen_on.png") no-repeat
                center center;
            }
          }
        }
      }
    }
  }
}
</style>
